import { render, staticRenderFns } from "./ItemGroupList.vue?vue&type=template&id=16df0fc7&scoped=true"
import script from "./ItemGroupList.vue?vue&type=script&lang=js"
export * from "./ItemGroupList.vue?vue&type=script&lang=js"
import style0 from "./ItemGroupList.vue?vue&type=style&index=0&id=16df0fc7&prod&lang=scss&scoped=true"
import style1 from "./ItemGroupList.vue?vue&type=style&index=1&id=16df0fc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16df0fc7",
  null
  
)

export default component.exports